module.exports = ".dialogtitle{\r\nbackground: #6ac451;\r\n    position: relative;\r\n    font-size: 20px;\r\n    line-height: 40px;\r\n    color: #fff;\r\n    font-weight: normal;\r\n    border-radius: 5px 5px 0 0;\r\n    width: 100%;\r\n    \r\n    padding: 0;\r\n   \r\n}\r\n\r\n.dialogtitle span\r\n  {\r\n    padding-left: 20px;\r\n    font-size: 20px;\r\n  }\r\n\r\n.mat-dialog-container\r\n  {\r\n    margin: 0px !important;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/devotee/devotee-message-for-admin/devotee-message-for-admin.component.css
// module id = ./src/app/devotee/devotee-message-for-admin/devotee-message-for-admin.component.css
// module chunks = main